/* SA market switcher (replaces Selecty selectors). Top market entries first; full list + search built lazily.
   Flags: theme country images (Shopify image_url) inside templates, so they load only when a list opens. */
(function () {
  var d = document, w = window, ls = localStorage, ss = sessionStorage;
  var top = d.getElementById('sa-market-top');
  var tpl = d.getElementById('sa-market-template'), form = d.getElementById('sa-market-form');
  if (!top || !tpl || !form) return;
  var M = JSON.parse(d.getElementById('sa-country-markets').textContent), G = w.SAGeo || {};
  function det() { try { return G.detected || ss.getItem('sa-geo-country') || ''; } catch (e) { return G.detected || ''; } }
  function caFirst() { return (det() || G.country) === 'CA'; }
  function resolve(c) {
    if (c !== 'EU') return c;
    var x = det(); if (M[x] === 'eu') return x;
    if (M[G.country] === 'eu') return G.country;
    return 'DE';
  }
  function choose(c) {
    c = resolve(c);
    try { ls.setItem('sa-market-choice', c); } catch (e) {}
    d.cookie = 'sa_market_choice=' + c + ';path=/;max-age=31536000;samesite=lax';
    form.querySelector('[name=country_code]').value = c;
    var rt = form.querySelector('[name=return_to]');
    if (rt) { var u = new URL(rt.value, location.origin); u.searchParams.delete('sa_geo_test'); rt.value = u.pathname + u.search; }
    form.submit();
  }
  function topFrag() {
    var f = top.content.cloneNode(true), l = f.querySelector('.sa-ms-top');
    var us = l.querySelector('[data-c="US"]'), ca = l.querySelector('[data-c="CA"]');
    if (us && ca && caFirst()) l.insertBefore(ca, us);
    return f;
  }
  function buildFull(full) {
    if (full.firstChild) return;
    full.innerHTML = '<input class="sa-ms-search" type="search" placeholder="Search country" aria-label="Search country">';
    full.appendChild(tpl.content.cloneNode(true));
    var s = full.querySelector('.sa-ms-search');
    s.addEventListener('input', function () {
      var v = s.value.trim().toLowerCase();
      full.querySelectorAll('.sa-ms-list button').forEach(function (b) { b.hidden = !!v && b.dataset.n.indexOf(v) < 0; });
      full.querySelectorAll('.sa-ms-group').forEach(function (g) { g.hidden = !!v; });
    });
  }
  function more(btn) {
    var full = btn.parentNode.querySelector('.sa-ms-full'); buildFull(full);
    var o = full.hidden; full.hidden = !o; btn.setAttribute('aria-expanded', o);
    if (o) full.querySelector('.sa-ms-search').focus();
  }
  // Normal switchers: compact dropdown anchored to the button (toolbar/footer) or inline in the drawer.
  var pan = null, opener = null;
  function closePan() {
    if (!pan) return; pan.remove(); pan = null;
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener = null; }
  }
  function place() {
    if (!pan || !opener || pan.classList.contains('sa-ms-inline')) return;
    var r = opener.getBoundingClientRect(), vh = innerHeight, vw = innerWidth, pw = Math.min(320, vw - 16);
    var below = vh - r.bottom - 8, above = r.top - 8, up = below < 260 && above > below;
    pan.style.width = pw + 'px';
    pan.style.left = Math.max(8, Math.min(r.right - pw, vw - pw - 8)) + 'px';
    pan.style.maxHeight = Math.max(160, Math.min(480, up ? above : below)) + 'px';
    if (up) { pan.style.top = ''; pan.style.bottom = (vh - r.top + 6) + 'px'; } else { pan.style.bottom = ''; pan.style.top = (r.bottom + 6) + 'px'; }
    pan.classList.toggle('sa-ms-up', up);
  }
  function openPan(btn) {
    if (opener === btn) return closePan();
    closePan();
    pan = d.createElement('div'); pan.className = 'sa-ms-pan'; pan.setAttribute('role', 'listbox');
    pan.appendChild(topFrag()); opener = btn; btn.setAttribute('aria-expanded', 'true');
    var dr = btn.closest('.sa-ms-drawer');
    if (dr) { pan.classList.add('sa-ms-inline'); dr.appendChild(pan); }
    else { d.body.appendChild(pan); place(); }
    pan.addEventListener('click', function (e) {
      var m = e.target.closest('.sa-ms-more'); if (m) { more(m); place(); return; }
      var b = e.target.closest('button[data-c]'); if (b) choose(b.dataset.c);
    });
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pan) { var o = opener; closePan(); if (o) o.focus(); } }, true);
  addEventListener('resize', place); addEventListener('scroll', place, true);
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sa-market-open]');
    if (b) { e.preventDefault(); return openPan(b); }
    if (pan && !pan.contains(e.target)) closePan();
  });
})();
